module.exports = __webpack_public_path__ + "static/media/logo-prazske-ddm.1b7566ae.png";